import React, { useEffect, useState } from "react";
import { transformResultsToTableData } from "../../../../services/commonService";
import InsightTable from "../InsightTable";

function OwnershipAndStructure({ ownershipAndStructureData }) {
  const [tabData, setTabData] = useState([]);
  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {},
    },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     ownership: "b",
  //     public_float: "c",
  //     major_shareholders: "d",
  //     ownership_positive_insight: "b",
  //     ownership_negative_insight: "b",
  //     ownership_recent_development: "b",
  //     public_float_positive_insight: "c",
  //     public_float_negative_insight: "c",
  //     public_float_recent_development: "c",
  //     major_shareholders_positive_insight: "d",
  //     major_shareholders_negative_insight: "d",
  //     major_shareholders_recent_development: "d",
  //   },
  //   {
  //     competitor: "e",
  //     ownership: "f",
  //     public_float: "g",
  //     major_shareholders: "h",
  //     ownership_positive_insight: "b",
  //     ownership_negative_insight: "b",
  //     ownership_recent_development: "b",
  //     public_float_positive_insight: "c",
  //     public_float_negative_insight: "c",
  //     public_float_recent_development: "c",
  //     major_shareholders_positive_insight: "d",
  //     major_shareholders_negative_insight: "d",
  //     major_shareholders_recent_development: "d",
  //   },
  // ];
  useEffect(() => {
    const tableData = transformResultsToTableData(ownershipAndStructureData);
    setTabData(tableData);
  }, [ownershipAndStructureData]);

  const tableColumns = [
    { key: "ownership", label: "Ownership" },
    { key: "public_float", label: "Public Float" },
    { key: "major_shareholders", label: "Major Shareholders" },
  ];

  return (
    <InsightTable
      title="Ownership & Structure"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default OwnershipAndStructure;
